export function hasPermission (profile, permission) {
  return !!profile?.permissions?.includes(permission)
}

export const has = hasPermission
export const hasAny = (profile, permissions = []) => permissions.some(permission => has(profile, permission))
export const hasAll = (profile, permissions = []) => permissions.every(permission => has(profile, permission))

export const sectionAccess = {
  fieldwork: {
    registros: ['fieldwork.records.read'],
    maquinarias: ['fieldwork.machinery.read'],
    reportes: ['fieldwork.reports.read'],
    precios: ['fieldwork.prices.read']
  },
  inventory: {
    stock: ['inventory.stock.read'],
    movimientos: ['inventory.documents.read'],
    herramientas: ['inventory.assets.read'],
    catalogo: ['inventory.items.read'],
    configuracion: ['inventory.catalogs.read']
  }
}

export const routeAccess = [
  ['/', ['plant.home.read']],
  ['/entrada', ['plant.incomes.read']],
  ['/proceso', ['plant.processes.read']],
  ['/salida', ['plant.outcomes.read']],
  ['/trabajos-campo', sectionAccess.fieldwork.registros],
  ['/trabajos-campo/maquinarias', sectionAccess.fieldwork.maquinarias],
  ['/trabajos-campo/reportes', sectionAccess.fieldwork.reportes],
  ['/trabajos-campo/precios', sectionAccess.fieldwork.precios],
  ['/panol', sectionAccess.inventory.stock],
  ['/panol/movimientos', sectionAccess.inventory.movimientos],
  ['/panol/herramientas', sectionAccess.inventory.herramientas],
  ['/panol/catalogo', sectionAccess.inventory.catalogo],
  ['/panol/configuracion', sectionAccess.inventory.configuracion],
  ['/agrochemical', ['agrochemicals.products.read', 'agrochemicals.withdrawals.read', 'agrochemicals.applications.read']],
  ['/compania', ['catalog.companies.read']],
  ['/ubicacion', ['catalog.locations.read']],
  ['/ubicacion/tipos', ['catalog.location_types.read']],
  ['/lote', ['catalog.lots.read']],
  ['/usuario', ['security.users.read']],
  ['/administracion/roles', ['security.roles.read']],
  ['/administracion/permisos', ['security.permissions.read']],
  ['/administracion/auditoria', ['security.audit.read']]
]

export function homeFor (profile) {
  const match = routeAccess.find(([, permissions]) => hasAny(profile, permissions))
  if (match) return match[0]
  return '/sin-acceso'
}

export function createAccessGuard (store) {
  return async to => {
    if (to.meta.public) return true
    if (!store.state.authModule.sessionInitialized) await store.dispatch('authModule/validate')
    if (!store.getters['authModule/isAuthenticated']) return '/login'
    const profile = store.state.authModule.userProfile
    if (to.name === 'Fieldwork') {
      const section = to.params?.section || 'registros'
      if (sectionAccess.fieldwork[section] && !hasAny(profile, sectionAccess.fieldwork[section])) return homeFor(profile)
    }
    if (to.name === 'Inventory') {
      const section = to.params?.section || 'stock'
      if (sectionAccess.inventory[section] && !hasAny(profile, sectionAccess.inventory[section])) return homeFor(profile)
    }
    const allowed = to.meta.permission
      ? has(profile, to.meta.permission)
      : to.meta.permissions
        ? (to.meta.requireAll ? hasAll(profile, to.meta.permissions) : hasAny(profile, to.meta.permissions))
        : false
    if ((to.meta.permission || to.meta.permissions) && !allowed) return homeFor(profile)
    return to.meta.sessionOnly || to.meta.permission || to.meta.permissions ? true : '/sin-acceso'
  }
}
